<div class="pagination">
  <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between">
    @if(numberOfPages > 1) {
    <nav
      class="mb-4 sm:mb-0 sm:order-1"
      role="navigation"
      aria-label="Navigation"
    >
      <ul class="flex justify-center">
        <li class="ml-3 first:ml-0">
          <app-button
            variant="secondary"
            textColor="indigo"
            [disabled]="isFirstPage"
            (btnClick)="changePage(currentPage - 1)"
          >
            <ng-template appButtonText> &lt;- Previous </ng-template>
          </app-button>
        </li>
        <li class="ml-3 first:ml-0 text-center" *ngIf="!!perPageOptions">
          <div
            class="ord-hint font-medium text-slate-600 dark:text-slate-300 mt-2"
          >
            {{ currentPage }} - {{ numberOfPages }} of
            {{ numberOfPages }}
          </div>
        </li>
        <li class="ml-3 first:ml-0">
          <app-button
            variant="secondary"
            textColor="indigo"
            [disabled]="isLastPage || currentPage > numberOfPages"
            (btnClick)="changePage(currentPage + 1)"
          >
            <ng-template appButtonText> Next -&gt; </ng-template>
          </app-button>
        </li>
      </ul>
    </nav>
    } @if (!!perPageOptions && perPageOptions.length > 0) {

    <div class="flex items-start justify-start gap-2">
      <label for="per-page-select" class="ord-hint h-9 flex items-center">
        Rows per page
      </label>
      <mat-form-field
        id="per-page-select"
        appearance="outline"
        color="accent"
        class="ord-form-field ord-select w-24"
      >
        <mat-select
          class="ord-select"
          panelClass="ord-select-panel"
          [value]="perPage"
          (valueChange)="changePerPage($event)"
        >
          @for(option of perPageOptions; track $index) {
          <mat-option class="ord-option" [value]="option">
            {{ option }}
          </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    } @else if (numberOfPages > 1) {
    <div
      class="ord-hint ord-text-gray text-center sm:text-left"
    >
      Showing page
      <span class="font-medium text-slate-600 dark:text-slate-300">{{
        currentPage
      }}</span>
      of
      <span class="font-medium text-slate-600 dark:text-slate-300">{{
        numberOfPages
      }}</span>
    </div>
    }
  </div>
</div>
